module.exports = __webpack_public_path__ + "static/media/perche-2.89c6a8e2.svg";